import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import FloatingButtons from '@/pages/home/components/FloatingButtons';
import TestimonialsSection from '@/pages/home/components/TestimonialsSection';
import ProgressiveImage from '@/components/base/ProgressiveImage';
import VideoSection from '@/pages/referanslar/components/VideoSection';
import WhatsAppMessages from '@/pages/referanslar/components/WhatsAppMessages';

function ReferanslarHero() {
  return (
    <section className="relative pt-32 pb-20 bg-brand-navy overflow-hidden">
      <div className="absolute inset-0">
        <ProgressiveImage
          src="/media/search-image-c99aa0bdc4.jpg"
          alt="Referanslar ve Müşteri Yorumları"
          className="object-cover object-top opacity-20"
          priority
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-navy via-brand-navy/90 to-brand-navy/70"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-2 mb-6">
          <a href="/" className="text-white/50 text-sm hover:text-white transition-colors cursor-pointer">Anasayfa</a>
          <span className="text-white/30 text-sm">/</span>
          <span className="text-brand-orange text-sm font-medium">Referanslar</span>
        </div>
        <p className="text-brand-orange font-semibold text-sm uppercase tracking-widest mb-4">Müşteri Referansları</p>
        <h1 className="text-white font-heading font-bold text-4xl md:text-5xl mb-6 leading-tight">
          Müşterilerimiz<br />
          <span className="text-brand-orange">Ne Diyor?</span>
        </h1>
        <div className="flex flex-wrap items-center gap-6">
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-0.5">
              {[1,2,3,4,5].map(i => (
                <span key={i} className="w-5 h-5 flex items-center justify-center text-brand-orange">
                  <i className="ri-star-fill text-sm"></i>
                </span>
              ))}
            </div>
            <span className="text-white font-bold text-2xl">5.0</span>
            <span className="text-white/50 text-sm">ortalama puan</span>
          </div>
          <div className="h-8 w-px bg-white/20"></div>
          <div className="text-white/60 text-sm">
            <strong className="text-white">500+</strong> mutlu müşteri
          </div>
          <div className="h-8 w-px bg-white/20"></div>
          <div className="text-white/60 text-sm">
            <strong className="text-white">50+</strong> yıllık güven
          </div>
        </div>
      </div>
    </section>
  );
}

export default function ReferanslarPage() {
  return (
    <main className="font-sans">
      <Navbar />
      <ReferanslarHero />
      <VideoSection />
      <WhatsAppMessages />
      <TestimonialsSection />
      <Footer />
      <FloatingButtons />
    </main>
  );
}
